import React, { Component } from "react";
import { connect } from "react-redux";
import { Container } from "reactstrap";

import CustomLoader from "../../component/CustomLoader/CustomLoader";
import "./style.css";
import api from "../../config/api";
import { isNetworkRequestFailedError, logoutUser } from "../../config/helpers";
import historyAction from "../../redux/history/action";
import consentAction from "../../redux/consent/action";
import GradientButton from "../../component/GradientButton/GradientButton";
import authActions from "../../redux/auth/action";

class Consent extends Component {
  state = {
    isLoading: false,
    consent: "",
  };

  componentDidMount = async () => {
    const { history, setHistory, consent } = this.props;
    setHistory(history);

    let userData = sessionStorage.getItem("user");
    if (!userData) {
      history.replace("/login");
    }

    if (!consent) {
      this.getConsent();
    }
  };

  getConsent = async () => {
    const { setConsent } = this.props;

    try {
      this.setState({ isLoading: true });

      const response = await api.fetchConsent();
      let data = response.data.NdprClause;

      data = data.replace(/\n/g, "<br />");
      setConsent(data);
      this.setState({ consent: data });
    } catch (e) {
      console.log("e =>", e);
    }
    this.setState({ isLoading: false });
  };

  logoutUser = async () => {
    this.setState({ isLoading: true });
    await logoutUser(this.props);
    this.setState({ isLoading: false });
  };

  rejectConsent = () => {
    this.logoutUser();
  };

  acceptConsent = async () => {
    const { setAlertMessage, history } = this.props;

    try {
      let userData = sessionStorage.getItem("user");
      userData = JSON.parse(userData);
      let UserName = userData.User.UserName;
      let token = userData.token;

      const isNDPRAccepted = await api.acceptConsent(
        { userName: UserName, isAccepted: "Accepted" },
        token
      );

      if (
        isNDPRAccepted.data.Status != 200 && //eslint-disable-line
        isNDPRAccepted.data.ErrorCode != "00" //eslint-disable-line
      ) {
        throw new Error();
      }

      history.replace("/");

      setAlertMessage({ type: "success", message: "Successfull!" });
    } catch (error) {
      setAlertMessage({
        message: error.message,
        type: "error",
        onTryAgain: isNetworkRequestFailedError(error)
          ? this.acceptConsent
          : null,
      });
      history.replace("/login");
    }
  };
  render() {
    const { isLoading } = this.state;
    const { consent } = this.props;

    return (
      <div className="MainContainer">
        <div className="dataContainer">
          <Container className="py-4">
            {consent && <p dangerouslySetInnerHTML={{ __html: consent }} />}
          </Container>
        </div>

        {isLoading && <CustomLoader text="Please wait" />}

        <div className="p-2 text-center acceptBTN privacy-sticky-back-to-home BTNContainer d-flex">
          <GradientButton
            type="submit"
            containerClasses="ml-3"
            BTNClass="rejectBTNColor"
            label="Reject"
            onClick={() => this.rejectConsent()}
          />
          <GradientButton
            type="submit"
            containerClasses="rejectBTN "
            BTNClass="acceptBTNColor"
            label="Accept"
            onClick={() => this.acceptConsent()}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  consent: state.consent.consent,
  user: state.auth.user,
});

const mapDispatchToProps = {
  setHistory: historyAction.setHistory,
  setConsent: consentAction.setConsent,
  removeUser: authActions.removeUser,
  setAlertMessage: authActions.setAlertMessage,
  setUser: authActions.setUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(Consent);
